// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/moon.js';

import { paths } from '../generated/moon';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('moon', Original, paths);
